import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { AuthenticationValidationService } from './modules/shared/services/authentication-validation.service';
import { TrackMyLocationComponent } from './pages/track-my-location/track-my-location.component';
import { PaymentStripComponent } from './modules/payment-strip/payment-strip.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { SupportComponent } from './pages/support/support.component';
import { AuthorizeGatewayComponent } from './pages/authorize-gateway/authorize-gateway.component';
import { AuthorizeSuccessPageComponent } from './pages/authorize-success-page/authorize-success-page.component';
import { AuthorizedFailurePageComponent } from './pages/authorized-failure-page/authorized-failure-page.component';
import { AuthorizeCardDetailsComponent } from './pages/authorize-card-details/authorize-card-details.component';
import { AuthorizedPendingPaymentComponent } from './pages/authorized-pending-payment/authorized-pending-payment.component';
import { PrivacyPolicyV1Component } from './pages/privacy-policy-v1/privacy-policy-v1.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { DownloadComponent } from './modules/shared/components/download/download.component';
import { TenantConfigComponent } from './pages/tenant-config/tenant-config.component';
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'admin-dashboard',

    // canActivate: [AuthenticationValidationService]
    //  canActivate:[AuthGuard]

  },
  {
    path: 'sign-in',
    pathMatch: 'full',
    component: SignInComponent
  },
  {
    path: 'trackmylocation',
    pathMatch: 'full',
    component: TrackMyLocationComponent
  },
  // {
  //   path: 'privacy-policy',
  //   pathMatch: 'full',
  //   component: PrivacyPolicyComponent
  // },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    component: PrivacyPolicyV1Component
  },
  {
    path: 'terms-conditions',
    pathMatch: 'full',
    component: TermsAndConditionsComponent
  },
  {
    path: 'support',
    pathMatch: 'full',
    component: SupportComponent
  },
  {
    path: 'authorize-dot-net/add-update-card',
    pathMatch: 'full',
    component: AuthorizeGatewayComponent
  },
  {
    path: 'authorize-dot-net/wallet-topup',
    pathMatch: 'full',
    component: AuthorizeCardDetailsComponent
  },
  {
    path: 'authorize-dot-net/pending-payment',
    pathMatch: 'full',
    component: AuthorizedPendingPaymentComponent
  },
  {
    path: 'authorize-dot-net/success-page',
    pathMatch: 'full',
    component: AuthorizeSuccessPageComponent
  },
  {
    path: 'authorize-dot-net/failure-page',
    pathMatch: 'full',
    component: AuthorizedFailurePageComponent
  },
  {
    path: 'admin-dashboard',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule)
  },
  {
    path: 'bookings',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/bookings/bookings.module').then(m => m.BookingsModule)
  },
  {
    path: 'passengers',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/passengers/passengers.module').then(m => m.PassengersModule)
  },
  {
    path: 'manage-corporates',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/corporate-passenger/corporate-passenger.module').then(m => m.CorporatePassengerModule)
  },
  {
    path: 'occasional-trip',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/occasional-trip/occasional-trip.module').then(m => m.OccasionalTripModule)
  },
  {
    path: 'vehicles',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/vehicles/vehicles.module').then(m => m.VehiclesModule)
  },
  {
    path: 'drivers',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/drivers/drivers.module').then(m => m.DriversModule)
  },
  {
    path: 'manage-cities',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/manage-cities/manage-cities.module').then(m => m.ManageCitiesModule)
  },
  {
    path: 'manage-companies',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/manage-companies/manage-companies.module').then(m => m.ManageCompaniesModule)
  },
  {
    path: 'marketing',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/marketing/marketing.module').then(m => m.MarketingModule)
  },
  {
    path: 'app-settings',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/tenant-settings/tenant-settings.module').then(m => m.TenantSettingsModule)
  },
  {
    path: 'user-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule)
  },
  {
    path: 'operator-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/operator-management/operator-management.module').then(m => m.OperatorManagementModule)
  },
  {
    path: 'settings',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'reports',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'tenant-config',
    canActivate: [AuthenticationValidationService],
    component: TenantConfigComponent,
    pathMatch: 'full'
  },
  {
    path: 'payment',
    pathMatch: 'full',
    component: PaymentStripComponent
  },
  {
    path: 'app-release-history',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/app-release-history/app-release-history.module').then(m => m.AppReleaseHistoryModule)
  },
  {
    path: 'file/excel/:fileId',
    canActivate: [AuthenticationValidationService],
    component: DownloadComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
